import { TPerformanceRatingSummaryKey } from "@/pages/(admin)/performance-review/helper";

export const RATING_COLORS = {
  goingStrong: "text-[#14AE5C]",
  accelerating: "text-[#0080C8]",
  catchingUp: "text-[#EC2216]",
} as const;

export const getRatingColor = (bucket?: TPerformanceRatingSummaryKey): string => {
  return bucket ? RATING_COLORS[bucket] : "text-eerie-black";
};
